<ng-container [formGroup]="form">
    <div class="signerings-modal-header">
        <rask-header size="2">Digital signering av
            {{form.controls.kontraktBenamning.value}}</rask-header>
        <button type="button"
            id="btnLreClose"
            class="btn-close"
            aria-describedby="Alternativ för digital signering"
            (click)="close()">
        </button>
    </div>
    <div class="signerings-modal-body">
        <rask-validation-message-row
            message="Om ändringar har gjorts, kontrollera att nya versioner av kontrakt och karta har genererats och skickas med för signering."
            type="warning"
            class="mt-2 pb-0 validation-message-icon">
        </rask-validation-message-row>
        <div class="signering-modal-content" formArrayName="utskrifter">
            <rask-header class="p-0" size="3" noPadding>Huvuddokument och valfria bilagor</rask-header>
            <div>
                @if (kontraktUtskrifter$ | async; as utskriftInfo) {
                @for(utskrift of utskriftInfo.utskrifter; track utskrift.id; let index = $index){
                <rask-kontrakt-signering-utskrift
                    [utskrift]="utskrift"
                    [dokumentTyp]="dokumentTyp"
                    [form]="form">
                </rask-kontrakt-signering-utskrift>
                }
                <div class="bilagor-rubrik">Bilagor</div>
                @for(utskrift of utskriftInfo.ovrigaBilagor; track utskrift.id; let index = $index){
                <rask-kontrakt-signering-utskrift
                    [utskrift]="utskrift"
                    [dokumentTyp]="dokumentTyp"
                    [form]="form">
                </rask-kontrakt-signering-utskrift>
                }
                @if (utskriftInfo.ovrigaBilagor.length > 0) {
                <div>
                    <rask-selector
                        class="col-6 pl-0"
                        label="Lägg till"
                        [values]="getOvrigaBilagor(utskriftInfo)"
                        (change)="onOvrigBilagaChange($event)"
                        [viewFormatter]="formatter">
                    </rask-selector>
                </div>
                }
                }
            </div>
        </div>

        <div class="signering-modal-content" formArrayName="leverantorer">
            <rask-header class="p-0" size="3" noPadding>Vem som ska signera digitalt
                <rask-action-button (click)="addMottagare()" icon="fa fa-plus">Lägg till mottagare</rask-action-button>
            </rask-header>
            @for(signeringsDeltagare of deltagareList$ | async; track $index){
                @if(aktivSignering$ | async; as aktivSignering) {
                <rask-kontrakt-signering-leverantor
                    [deltagare]="signeringsDeltagare"
                    [aktivSignering]="aktivSignering"
                    [form]="form"
                    [dokumentTyp]="dokumentTyp">
                </rask-kontrakt-signering-leverantor>
                } @else {
                <rask-kontrakt-signering-leverantor
                    [deltagare]="signeringsDeltagare"
                    [form]="form"
                    [dokumentTyp]="dokumentTyp">
                </rask-kontrakt-signering-leverantor>
                }
            }

        </div>
        <div class="signering-forfalloinfo">
            <rask-header class="p-0" size="3" noPadding>Tidsperiod för signering</rask-header>
            <rask-input
                class="signering-antaldagar"
                label="Antal dagar"
                formControlName="giltigAntalDagar">
            </rask-input>
            <rask-input
                label="Planerat förfallodatum"
                [readonly]="true"
                [value]="endDate">
            </rask-input>
        </div>
    </div>
 @if(!correctOrder()){
                <rask-validation-message-row message="Mottagare måste anges i en kontinuerlig följd med start på 1. Flera mottagare kan ha samma nummer." type="error">
                </rask-validation-message-row>
            }
    <div class="signerings-modal-footer">

        <div class="d-flex ms-auto">
            @if(form.touched && form.invalid){
            <rask-virkeskop-validation-icon-popover entityType="digitalsignering">
                @for(error of getErrors(); track $index){
                <span #message>{{error}}</span>
                }
            </rask-virkeskop-validation-icon-popover>
            }
            <rask-button class="signering-modal-footer-button" color="primary" [disabled]="form.touched && form.invalid"
                (click)="saveClick()">
                <i class="fa-solid fa fa-paper-plane"></i>
                <span class="ms-1">Skicka</span>
            </rask-button>
        </div>
        <rask-button class="signering-modal-footer-button" aid="buttonFkAvbryt" color="secondary" (click)="close()"
            ngbAutofocus>Avbryt</rask-button>
    </div>
</ng-container>